import ProductsListValueObject from './ProductsListValueObject.js'

export default class ProductsValueObjectsFactory {
  static productsListValueObject = ({products}) => new ProductsListValueObject({products})
}
